/**
 * MyGemaPro APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface QrMaintenanceTimerCreateDto { 
    buildingEquipmentId: string;
    type: QrMaintenanceTimerCreateDto.TypeEnum;
    creatorName?: string;
    durationDays?: number;
    reminderDurationDays?: number;
    earlyToleranceDays?: number;
    lateToleranceDays?: number;
    imagesMandatory?: boolean;
}
export namespace QrMaintenanceTimerCreateDto {
    export type TypeEnum = 'Maintenance' | 'Inspection' | 'SelfInspection' | 'Warranty';
    export const TypeEnum = {
        Maintenance: 'Maintenance' as TypeEnum,
        Inspection: 'Inspection' as TypeEnum,
        SelfInspection: 'SelfInspection' as TypeEnum,
        Warranty: 'Warranty' as TypeEnum
    };
}


